import React, { useEffect, useState } from "react";
import CpntDropdownPage from './dataTable/CpntDropdown';
import { Pagination } from "react-bootstrap";

interface IProps {
  limit: number;
  offset:number;
  numberOfResults:number;
  setLimit: (Limit: number)=> void;
  setOffset: (offset: number) =>void;
}

const CpntPagination: React.FC<IProps> = ({
  limit,
  offset,
  setLimit,
  setOffset,
  numberOfResults
}) => {


const [nbPages, setNbPages] = useState<number>(0);


    useEffect(() => {
      numberOfResults && limit && setNbPages(Math.ceil(numberOfResults / limit))
    }, [numberOfResults ,limit])

    useEffect(() => {
      if (nbPages && (offset>=nbPages)) {
        setOffset(nbPages-1)
      }
    }, [nbPages])
   

  // console.log("nbPages",nbPages);
  // console.log("Math.floor nbPages",Math.floor(nbPages));
  // console.log("offset",offset);
    return (
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
              <div className="col-1.5" style={{margin:"5px"}}>
                Nombre par page: 
              </div> 
              &nbsp;&nbsp;
              <div className="col-0.5">
                <CpntDropdownPage value={limit} 
                title="" 
                itemsList={[10, 20, 50, 100]} 
                onChange={(limit) => {
                  setLimit(limit);
           
                  }}/>
              </div>
             
              <div className="col-2.5" style={{float:"left"}}>
                <Pagination >
                  <Pagination.First style={{marginLeft:"5px",marginRight:"5px"}} hidden={offset === 0 ? true : false} onClick={() => setOffset(0)} />
                  <Pagination.Prev style={{marginRight:"5px"}} hidden={offset <= 0 ? true : false} onClick={() => setOffset(offset - 1)} />
                  <div className="col-1.5" style={{margin:"5px"}}>
                {offset +1}/{nbPages} 
                {/* {numberOfResults} */}
              </div>
                  {/* <Pagination.Item hidden={index <= 0 ? true : false } onClick={() => onChangeMethod(index - 1)} >{index}</Pagination.Item> */}
                  {/* <Pagination.Item active>{index + 1}</Pagination.Item> */}
                  {/* <Pagination.Item hidden={index >= maxPagination ? true : false} onClick={() => onChangeMethod(index + 1)} >{index + 2}</Pagination.Item> */}
                  <Pagination.Next style={{marginLeft:"5px",marginRight:"5px"}} hidden={(nbPages <= 1 || offset+1 >= nbPages)? true : false} onClick={() => setOffset(offset + 1)} />
                  <Pagination.Last style={{marginRight:"5px"}} hidden={(nbPages <= 1 || offset+1 >= nbPages) ? true : false} onClick={() => setOffset(nbPages-1)} />
                </Pagination>
              </div>
              &nbsp;&nbsp;
              
      </div>
    );
  };
  
  export default CpntPagination;
  